import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FaArrowLeft,
  FaGlobe,
  FaHourglassHalf,
  FaIndustry,
  FaArrowUp
} from 'react-icons/fa';

import { GiWheat } from 'react-icons/gi';

import logoImage from '../logos/AshrafFood/Ashrafiafoodlogo.png';
import topImagesImage from '../logos/AshrafFood/ashraffood1.png';
import productImage from '../logos/AshrafFood/ashraffood.png';


export default function AshrafiaFood() {

  const navigate = useNavigate();

  return (
    <div className="ashrafia-page">

      {/* =====================================================
          PAGE CSS
      ===================================================== */}

      <style>{`

        * {
          box-sizing: border-box;
        }

        .ashrafia-page {
          width: 100%;
          min-height: 100vh;
          background:
            radial-gradient(
              circle at top right,
              rgba(197,160,89,0.10),
              transparent 35%
            ),
            linear-gradient(
              135deg,
              #f4f7f5 0%,
              #eef2f5 50%,
              #f8f5ef 100%
            );

          padding: 20px 32px 40px;
          color: #333;
          font-family:
            Georgia,
            "Times New Roman",
            serif;

          overflow-x: hidden;
        }


        /* =====================================================
           PAGE ENTRANCE
        ===================================================== */

        .poster-card {
          animation: posterAppear 0.8s ease-out both;
        }

        .animate-item {
          animation: fadeUp 0.8s ease-out both;
        }

        .animate-delay-1 {
          animation-delay: 0.15s;
        }

        .animate-delay-2 {
          animation-delay: 0.30s;
        }

        .animate-delay-3 {
          animation-delay: 0.45s;
        }

        .animate-delay-4 {
          animation-delay: 0.60s;
        }


        @keyframes posterAppear {

          from {
            opacity: 0;
            transform: translateY(25px) scale(0.985);
          }

          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }

        }


        @keyframes fadeUp {

          from {
            opacity: 0;
            transform: translateY(25px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }

        }


        @keyframes floating {

          0%,
          100% {
            transform: translateY(0);
          }

          50% {
            transform: translateY(-7px);
          }

        }


        /* =====================================================
           TOP NAV
        ===================================================== */

        .top-nav {
          width: 100%;
          margin: 0 auto 18px;
        }


        .back-button {
          background:
            linear-gradient(
              135deg,
              #0f4c2e,
              #176b43
            );

          color: white;

          border: 1px solid rgba(255,255,255,0.20);

          padding: 12px 20px;

          border-radius: 8px;

          cursor: pointer;

          display: inline-flex;

          align-items: center;

          font-weight: 700;

          font-size: 14px;

          font-family: Arial, sans-serif;

          box-shadow:
            0 7px 18px rgba(15,76,46,0.18);

          transition:
            transform 0.25s ease,
            box-shadow 0.25s ease,
            background 0.25s ease;
        }


        .back-button:hover {
          transform: translateY(-3px);

          box-shadow:
            0 12px 25px rgba(15,76,46,0.25);

          background:
            linear-gradient(
              135deg,
              #176b43,
              #0f4c2e
            );
        }


        .back-button:active {
          transform: translateY(0);
        }


        /* =====================================================
           MAIN POSTER
        ===================================================== */

        .poster-card {
          width: 100%;

          margin: 0 auto;

          background:
            linear-gradient(
              180deg,
              #fffefb 0%,
              #fffdf9 100%
            );

          border-radius: 18px;

          border: 1px solid #ded7ca;

          box-shadow:
            0 25px 70px rgba(0,0,0,0.10),
            0 5px 20px rgba(15,76,46,0.05);

          overflow: hidden;

          padding: 38px 42px;

          position: relative;
        }


        .poster-card::before {
          content: "";

          position: absolute;

          top: 0;
          left: 0;
          right: 0;

          height: 5px;

          background:
            linear-gradient(
              90deg,
              #0f4c2e,
              #c5a059,
              #0f4c2e
            );
        }


        /* =====================================================
           HEADER
        ===================================================== */

        .header {
          display: flex;

          align-items: center;

          justify-content: space-between;

          gap: 30px;

          padding:
            10px
            5px
            28px;

          border-bottom:
            1px solid #e7e0d5;
        }


        .header-left {
          display: flex;

          align-items: center;

          gap: 18px;

          flex: 0 0 39%;
        }


        /* =====================================================
           LOGO
        ===================================================== */

        .logo-area {
          width: 92px;
          height: 92px;

          flex-shrink: 0;

          display: flex;

          align-items: center;

          justify-content: center;

          border-radius: 50%;

          background: #ffffff;

          padding: 5px;

          box-shadow:
            0 5px 18px rgba(15,76,46,0.10);

          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease;
        }


        .logo-area:hover {
          transform: scale(1.06) rotate(-2deg);

          box-shadow:
            0 9px 25px rgba(15,76,46,0.18);
        }


        .logo-image {
          width: 100%;
          height: 100%;

          object-fit: contain;

          display: block;
        }


        .header-left-text {
          display: flex;

          flex-direction: column;
        }


        .brand-title {
          margin: 0;

          font-size: clamp(22px, 2vw, 30px);

          color: #0f4c2e;

          letter-spacing: 2px;

          font-weight: 800;
        }


        .brand-tag {
          margin: 3px 0 0;

          font-size: 11px;

          color: #0f4c2e;

          font-weight: 700;

          letter-spacing: 1px;

          font-family: Arial, sans-serif;
        }


        .brand-sub {
          margin: 5px 0 0;

          font-size: 11px;

          color: #c5a059;

          font-weight: 700;

          letter-spacing: 1.5px;
        }


        /* =====================================================
           DIVIDER
        ===================================================== */

        .header-divider {
          width: 1px;

          height: 95px;

          background:
            linear-gradient(
              to bottom,
              transparent,
              #c5a059,
              transparent
            );

          flex-shrink: 0;
        }


        /* =====================================================
           HEADER RIGHT
        ===================================================== */

        .header-right {
          text-align: right;

          flex: 1;
        }


        .main-title {
          margin: 0;

          font-size: clamp(27px, 3vw, 46px);

          color: #0f4c2e;

          letter-spacing: 1.5px;

          line-height: 1.13;

          font-weight: 700;
        }


        .tagline {
          margin: 10px 0 0;

          font-style: italic;

          font-size: clamp(15px, 1.5vw, 20px);

          color: #a77b28;

          font-weight: 500;
        }


        /* =====================================================
           TOP IMAGE
        ===================================================== */

        .top-image-section {
          width: 100%;

          margin: 30px 0;

          overflow: hidden;

          border-radius: 12px;

          background: #ffffff;

          box-shadow:
            0 10px 30px rgba(0,0,0,0.09);

          position: relative;
        }


        .top-image-section::after {
          content: "";

          position: absolute;

          inset: 0;

          pointer-events: none;

          background:
            linear-gradient(
              90deg,
              rgba(15,76,46,0.05),
              transparent 30%,
              transparent 70%,
              rgba(197,160,89,0.08)
            );
        }


        .top-image {
          width: 100%;

          height: auto;

          min-height: 330px;

          max-height: 560px;

          object-fit: cover;

          display: block;

          transition:
            transform 0.8s ease;
        }


        .top-image-section:hover .top-image {
          transform: scale(1.015);
        }


        /* =====================================================
           ABOUT SECTION
        ===================================================== */

        .about-section {
          display: grid;

          grid-template-columns:
            minmax(0, 1.15fr)
            minmax(320px, 0.85fr);

          gap: 50px;

          margin: 50px 0;

          align-items: center;

          padding:
            10px 25px;
        }


        .about-text-column {
          min-width: 0;
        }


        .section-title-row {
          display: flex;

          align-items: center;

          gap: 10px;

          margin-bottom: 18px;
        }


        .section-header {
          font-size: clamp(24px, 2vw, 30px);

          color: #0f4c2e;

          letter-spacing: 1.5px;

          margin: 0;

          position: relative;
        }


        .section-header::after {
          content: "";

          display: block;

          width: 55px;

          height: 3px;

          background: #c5a059;

          margin-top: 8px;

          border-radius: 10px;
        }


        .paragraph {
          font-size: 15px;

          line-height: 1.8;

          color: #4b4b4b;

          margin:
            0 0 15px;
        }


        .green-text {
          color: #0f4c2e;

          margin:
            0 4px;

          font-weight: 700;
        }


        /* =====================================================
           PRODUCT IMAGE
        ===================================================== */

        .product-image-column {
          display: flex;

          justify-content: center;

          align-items: center;
        }


        .product-image-frame {
          width: 100%;

          max-width: 500px;

          padding: 14px;

          background:
            linear-gradient(
              145deg,
              #fff,
              #faf6ee
            );

          border:
            1px solid #e1d5c2;

          border-radius: 16px;

          box-shadow:
            0 15px 35px rgba(0,0,0,0.08);

          animation:
            floating 5s ease-in-out infinite;
        }


        .product-image {
          width: 100%;

          height: auto;

          max-height: 450px;

          object-fit: contain;

          display: block;

          border-radius: 10px;
        }


        /* =====================================================
           FEATURES
        ===================================================== */

        .features-section {
          margin:
            50px 0 35px;
        }


        .features-grid {
          display: grid;

          grid-template-columns:
            repeat(4, 1fr);

          gap: 18px;
        }


        .feature-card {
          background:
            linear-gradient(
              180deg,
              #ffffff,
              #fbfaf7
            );

          border:
            1px solid #e2d7c5;

          border-radius: 14px;

          padding:
            27px 18px;

          text-align: center;

          display: flex;

          flex-direction: column;

          align-items: center;

          min-height: 250px;

          transition:
            transform 0.3s ease,
            box-shadow 0.3s ease,
            border-color 0.3s ease;
        }


        .feature-card:hover {
          transform:
            translateY(-8px);

          border-color:
            rgba(15,76,46,0.35);

          box-shadow:
            0 15px 35px rgba(15,76,46,0.10);
        }


        .icon-circle {
          width: 60px;
          height: 60px;

          border-radius: 50%;

          border:
            2px solid #0f4c2e;

          background:
            #f2f8f4;

          color: #0f4c2e;

          display: flex;

          align-items: center;

          justify-content: center;

          font-size: 25px;

          margin-bottom: 16px;

          transition:
            transform 0.3s ease,
            background 0.3s ease;
        }


        .feature-card:hover .icon-circle {
          transform:
            rotate(8deg)
            scale(1.08);

          background:
            #e8f2eb;
        }


        .feature-title {
          margin:
            0 0 10px;

          font-size: 13px;

          color: #0f4c2e;

          font-weight: 800;

          font-family: Arial, sans-serif;

          line-height: 1.4;

          letter-spacing: 0.3px;
        }


        .feature-desc {
          margin: 0;

          font-size: 12px;

          color: #555;

          line-height: 1.6;
        }


        /* =====================================================
           QUOTE
        ===================================================== */

        .callout-quote {
          display: flex;

          align-items: center;

          justify-content: center;

          gap: 16px;

          border-top:
            1px solid #e2d7c5;

          border-bottom:
            1px solid #e2d7c5;

          padding:
            22px 20px;

          margin:
            35px 0 25px;

          background:
            linear-gradient(
              90deg,
              transparent,
              rgba(197,160,89,0.07),
              transparent
            );
        }


        .quote-decoration {
          color: #c5a059;

          font-size: 22px;
        }


        .quote-text {
          margin: 0;

          font-size: clamp(17px, 2vw, 23px);

          font-style: italic;

          color: #0f4c2e;

          font-weight: 700;

          text-align: center;
        }


        /* =====================================================
           FOOTER
        ===================================================== */

        .footer {
          position: relative;

          margin-top: 10px;

          padding:
            28px 30px;

          border-radius: 14px;

          background:
            linear-gradient(
              135deg,
              #0a3d25 0%,
              #0f4c2e 50%,
              #145f3b 100%
            );

          color: white;

          display: grid;

          grid-template-columns:
            1fr auto;

          align-items: center;

          gap: 25px;

          overflow: hidden;

          box-shadow:
            0 12px 35px rgba(15,76,46,0.18);
        }


        .footer::before {
          content: "";

          position: absolute;

          width: 220px;
          height: 220px;

          border-radius: 50%;

          right: -80px;
          top: -100px;

          background:
            rgba(197,160,89,0.12);
        }


        .footer::after {
          content: "";

          position: absolute;

          width: 130px;
          height: 130px;

          border-radius: 50%;

          left: -60px;
          bottom: -70px;

          background:
            rgba(255,255,255,0.04);
        }


        .footer-company {
          position: relative;

          z-index: 2;

          display: flex;

          flex-direction: column;

          gap: 7px;
        }


        .footer-company strong {
          font-family: Arial, sans-serif;

          font-size: clamp(18px, 2vw, 27px);

          font-weight: 900;

          letter-spacing: 1.5px;

          color: #ffffff;

          text-transform: uppercase;
        }


        .footer-company span {
          font-family: Arial, sans-serif;

          font-size: 13px;

          color: #e7d7b5;

          letter-spacing: 0.7px;
        }


        .footer-link {
          position: relative;

          z-index: 2;

          display: inline-flex;

          align-items: center;

          justify-content: center;

          gap: 8px;

          padding:
            13px 20px;

          border:
            1px solid rgba(255,255,255,0.25);

          border-radius: 50px;

          background:
            rgba(255,255,255,0.08);

          font-family: Arial, sans-serif;

          transition:
            background 0.3s ease,
            transform 0.3s ease,
            border-color 0.3s ease;
        }


        .footer-link:hover {
          background:
            rgba(197,160,89,0.18);

          border-color:
            rgba(197,160,89,0.65);

          transform:
            translateY(-3px);
        }


        .footer-link-icon {
          color: #e0b95f;

          font-size: 15px;
        }


        .link-text {
          color: white;

          text-decoration: none;

          font-size: 13px;

          font-weight: 800;

          letter-spacing: 0.5px;
        }


        /* =====================================================
           RESPONSIVE - TABLET
        ===================================================== */

        @media (max-width: 1000px) {

          .ashrafia-page {
            padding:
              18px 20px 30px;
          }


          .poster-card {
            padding:
              30px 25px;
          }


          .header {
            gap: 20px;
          }


          .header-left {
            flex: 0 0 42%;
          }


          .main-title {
            font-size: 28px;
          }


          .features-grid {
            grid-template-columns:
              repeat(2, 1fr);
          }


          .about-section {
            grid-template-columns:
              1fr 1fr;

            gap: 30px;

            padding:
              10px;
          }

        }


        /* =====================================================
           RESPONSIVE - MOBILE
        ===================================================== */

        @media (max-width: 700px) {

          .ashrafia-page {
            padding:
              12px 10px 25px;
          }


          .top-nav {
            margin-bottom: 12px;
          }


          .back-button {
            width: 100%;

            justify-content: center;

            padding: 12px 15px;
          }


          .poster-card {
            padding:
              24px 15px;

            border-radius: 14px;
          }


          .header {
            flex-direction: column;

            text-align: center;

            padding:
              8px 5px 22px;

            gap: 20px;
          }


          .header-left {
            width: 100%;

            flex: none;

            justify-content: center;

            flex-direction: column;

            gap: 10px;
          }


          .logo-area {
            width: 85px;
            height: 85px;
          }


          .header-left-text {
            align-items: center;
          }


          .brand-title {
            font-size: 23px;
          }


          .brand-tag {
            font-size: 9px;
          }


          .header-divider {
            width: 70px;

            height: 1px;
          }


          .header-right {
            width: 100%;

            text-align: center;
          }


          .main-title {
            font-size: 26px;

            line-height: 1.2;
          }


          .tagline {
            font-size: 15px;
          }


          .top-image-section {
            margin:
              20px 0;
          }


          .top-image {
            min-height: 200px;

            height: auto;

            object-fit: contain;
          }


          .about-section {
            display: flex;

            flex-direction: column;

            gap: 25px;

            margin:
              30px 0;

            padding:
              5px;
          }


          .about-text-column,
          .product-image-column {
            width: 100%;
          }


          .section-title-row {
            justify-content: flex-start;
          }


          .section-header {
            font-size: 23px;
          }


          .paragraph {
            font-size: 14px;

            line-height: 1.75;
          }


          .product-image-frame {
            max-width: 430px;

            animation: none;
          }


          .product-image {
            max-height: none;
          }


          .features-section {
            margin:
              30px 0 20px;
          }


          .features-grid {
            grid-template-columns:
              1fr;

            gap: 14px;
          }


          .feature-card {
            min-height: auto;

            padding:
              24px 18px;
          }


          .icon-circle {
            width: 55px;
            height: 55px;
          }


          .callout-quote {
            padding:
              18px 12px;

            gap: 8px;
          }


          .quote-decoration {
            font-size: 17px;
          }


          .quote-text {
            font-size: 15px;
            line-height: 1.5;
          }


          .footer {
            grid-template-columns:
              1fr;

            text-align: center;

            padding:
              25px 18px;

            gap: 18px;
          }


          .footer-company {
            align-items: center;
          }


          .footer-company strong {
            font-size: 19px;

            line-height: 1.3;
          }


          .footer-company span {
            font-size: 12px;
          }


          .footer-link {
            justify-self: center;

            width: 100%;

            max-width: 300px;
          }

        }


        /* =====================================================
           SMALL MOBILE
        ===================================================== */

        @media (max-width: 400px) {

          .poster-card {
            padding:
              20px 12px;
          }


          .main-title {
            font-size: 22px;
          }


          .brand-title {
            font-size: 20px;
          }


          .tagline {
            font-size: 14px;
          }


          .paragraph {
            font-size: 13px;
          }


          .footer-company strong {
            font-size: 16px;
          }


          .link-text {
            font-size: 11px;
          }

        }


        /* =====================================================
           REDUCED MOTION
        ===================================================== */

        @media (prefers-reduced-motion: reduce) {

          .poster-card,
          .animate-item,
          .product-image-frame {
            animation: none !important;
          }


          .back-button,
          .feature-card,
          .icon-circle,
          .logo-area,
          .footer-link,
          .top-image {
            transition: none !important;
          }

        }

      `}</style>


      {/* =====================================================
          TOP NAVIGATION
      ===================================================== */}

      <div className="top-nav">

        <button
          className="back-button"
          onClick={() => navigate('/')}
        >

          <FaArrowLeft
            style={{
              marginRight: '8px'
            }}
          />

          Back to All Sectors

        </button>

      </div>


      {/* =====================================================
          MAIN POSTER
      ===================================================== */}

      <div className="poster-card">


        {/* =====================================================
            HEADER
        ===================================================== */}

        <header className="header animate-item">


          {/* LOGO */}

          <div className="header-left">

            <div className="logo-area">

              <img
                src={logoImage}
                alt="Ashrafia Food & Processing Industries Logo"
                className="logo-image"
              />

            </div>


            <div className="header-left-text">

              <h3 className="brand-title">
                ASHRAFIA
              </h3>

              <p className="brand-tag">
                FOOD & PROCESSING INDUSTRIES
              </p>

              <p className="brand-sub">
                — SINCE 1990 —
              </p>

            </div>

          </div>


          {/* DIVIDER */}

          <div className="header-divider"></div>


          {/* TITLE */}

          <div className="header-right">

            <h1 className="main-title">

              ASHRAFIA FOOD &<br />

              PROCESSING INDUSTRIES

            </h1>

            <p className="tagline">

              Premium Rice Export Division

            </p>

          </div>

        </header>



        {/* =====================================================
            TOP IMAGE
        ===================================================== */}

        <section
          className="
            top-image-section
            animate-item
            animate-delay-1
          "
        >

          <img
            src={topImagesImage}
            alt="Ashrafia Rice Processing and Agriculture"
            className="top-image"
          />

        </section>



        {/* =====================================================
            ABOUT US
        ===================================================== */}

        <section
          className="
            about-section
            animate-item
            animate-delay-2
          "
        >


          {/* LEFT TEXT */}

          <div className="about-text-column">

            <div className="section-title-row">

              <h2 className="section-header">
                ABOUT US
              </h2>

              <GiWheat
                style={{
                  color: '#c5a059',
                  fontSize: '22px'
                }}
              />

            </div>


            <p className="paragraph">

              Established in 1990, Ashrafia Food & Processing
              Industries represents the Ashraf Group's commitment
              to delivering

              <strong className="green-text">
                premium food products
              </strong>

              to global markets.

            </p>


            <p className="paragraph">

              Specializing in the export of

              <strong className="green-text">
                high-quality Pakistani rice
              </strong>,

              the company has built a reputation for excellence
              through strict quality control, careful sourcing,
              and modern processing techniques.

            </p>


            <p className="paragraph">

              We procure the finest paddy and preserve it through
              a natural aging process, ensuring that every grain
              retains its

              <strong className="green-text">
                distinct aroma, delicate texture, and authentic taste.
              </strong>

            </p>


            <p className="paragraph">

              With a strong focus on consistency and customer
              satisfaction, Ashrafia Food continues to bring the
              true essence of Pakistan's agriculture to international
              markets.

            </p>

          </div>



          {/* RIGHT PRODUCT IMAGE */}

          <div className="product-image-column">

            <div className="product-image-frame">

              <img
                src={productImage}
                alt="Ashrafia 1121 Basmati Rice"
                className="product-image"
              />

            </div>

          </div>

        </section>



        {/* =====================================================
            FEATURES
        ===================================================== */}

        <section
          className="
            features-section
            animate-item
            animate-delay-3
          "
        >

          <div className="features-grid">


            {/* CARD 1 */}

            <div className="feature-card">

              <div className="icon-circle">

                <GiWheat />

              </div>

              <h4 className="feature-title">

                PREMIUM QUALITY
                <br />
                SOURCING

              </h4>

              <p className="feature-desc">

                Only the finest paddy is selected to ensure
                superior output and exceptional quality.

              </p>

            </div>



            {/* CARD 2 */}

            <div className="feature-card">

              <div className="icon-circle">

                <FaHourglassHalf />

              </div>

              <h4 className="feature-title">

                NATURAL AGING
                <br />
                PROCESS

              </h4>

              <p className="feature-desc">

                Rice aged for over a year in controlled
                environments to enhance aroma, texture
                and cooking quality.

              </p>

            </div>



            {/* CARD 3 */}

            <div className="feature-card">

              <div className="icon-circle">

                <FaGlobe />

              </div>

              <h4 className="feature-title">

                GLOBAL EXPORT
                <br />
                PRESENCE

              </h4>

              <p className="feature-desc">

                Trusted by customers across multiple
                countries with a strong commitment to
                reliability and integrity.

              </p>

            </div>



            {/* CARD 4 */}

            <div className="feature-card">

              <div className="icon-circle">

                <FaIndustry />

              </div>

              <h4 className="feature-title">

                MODERN PROCESSING
                <br />
                & PACKAGING

              </h4>

              <p className="feature-desc">

                Advanced milling, sorting and hygienic
                packaging ensure superior quality and
                global compliance.

              </p>

            </div>

          </div>

        </section>



        {/* =====================================================
            QUOTE
        ===================================================== */}

        <div
          className="
            callout-quote
            animate-item
            animate-delay-4
          "
        >

          <span className="quote-decoration">
            🌾
          </span>

          <p className="quote-text">

            “Delivering the true essence of Pakistani rice to the world.”

          </p>

          <span className="quote-decoration">
            🌾
          </span>

        </div>



        {/* =====================================================
            FOOTER
        ===================================================== */}

        <footer className="footer">


          {/* COMPANY */}

          <div className="footer-company">

            <strong>
              ASHRAF GROUP OF INDUSTRIES
            </strong>

            <span>
              Building Legacy. Powering the Future.
            </span>

          </div>


          {/* WEBSITE */}

          <div className="footer-link">

            <FaGlobe className="footer-link-icon" />

            <a
              href="https://www.ashrafiafood.com"
              target="_blank"
              rel="noreferrer"
              className="link-text"
            >
              www.ashrafiafood.com
            </a>

          </div>

        </footer>

      </div>

    </div>
  );
}